import { verificationConstants } from "../actions/actionTypes";

export const verification = (state = {}, action) => {
  if (action != null) {
    switch (action.type) {
      case verificationConstants.CHECK_USER_REQUEST:
        return state;
      case verificationConstants.CHECK_USER_FAILURE:
        return { expired: true };
      case verificationConstants.CHECK_USER_SUCCESS:
        return { success: true };
      default:
        return state;
    }
  }
};
